import React from 'react';
import { DropdownItem } from "../../design_system/components/Dropdown/DropdownItem.jsx";

const ShareOn = ({
    icon,
    text,
    url,
    label
}) => {
    return (
        <DropdownItem
            IconName={icon} 
            customStyle={{ padding: "8px 12px" }}
            onClick={() => {window.open(url, label, "width=660,height=400,scrollbars=no;resizable=no")}}
        >
            {text}
        </DropdownItem>
    );
}

const getElements = (params) => {
    const FacebookUrl = "https://www.facebook.com/sharer/sharer.php?" + SocialGetUrl(params["Facebook"]);
    const LinkedinUrl = "https://www.linkedin.com/shareArticle?mini=true&" + SocialGetUrl(params["LinkedIn"]);
    const TwitterUrl = "https://twitter.com/intent/tweet?mini=true&" + SocialGetUrl(params["Twitter"]);
    const SUB_SECTIONS = {
        "Facebook": {
            url: FacebookUrl,  //if this doesn't work, use OG like this <meta property="og:title" content="your-title" />
            icon: "facebook"         
        },
        "LinkedIn": {
            url: LinkedinUrl,
            icon: "linkedin" 
        },
        "Twitter": {
            url: TwitterUrl,
            icon: "x" 
        },
    };
    return SUB_SECTIONS;
}
const SocialGetUrl = (data) => {
    return Object.keys(data).map(function(key) {
        return [key, data[key]].map(encodeURIComponent).join("=");
    }).join("&");
}

//Icon,Text,Link
export {ShareOn, SocialGetUrl, getElements};
